module.exports = __webpack_public_path__ + "ebe4cadc.svg";